import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './config/rem.js'
Vue.config.productionTip = false

import "u-reset.css";
import VeHistogram from 'v-charts/lib/histogram.common'
import VeWaterfall from 'v-charts/lib/waterfall.common'
Vue.component(VeWaterfall.name, VeWaterfall)
Vue.component(VeHistogram.name, VeHistogram)

import VideoPlayer from 'vue-video-player'
require('video.js/dist/video-js.css')
require('vue-video-player/src/custom-theme.css')
Vue.use(VideoPlayer)


Vue.filter("date",function(val,format='MM/dd'){
	if(isNaN(val)){
		val = val.replace(/-/g, "/");
	}
    var date = new Date(val);
    if (/(y+)/.test(format)) {
        format = format.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length))
    }
    let o = {
        'M+': date.getMonth() + 1,
        'd+': date.getDate(),
        'h+': date.getHours(),
        'm+': date.getMinutes(),
        's+': date.getSeconds()
    };
    for(let k in o){
        if (new RegExp(`(${k})`).test(format)) {
            let str = o[k] + '';
            format = format.replace(RegExp.$1, (RegExp.$1.length === 1) ? str : ('00' + str).substr(str.length));
        }
    }
    return format;
})
Vue.filter("time",function(val){
	if(val == '--'){return '--h --m'}
	let H = Math.floor(val/60);
	let M = val%60;
    return `${H}h ${M}m`;
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
